<template>
    <div
        v-if="showList"
        class="bg-slate-50 pt-2 px-2 pb-3 mb-3 rounded-lg md:p-3"
    >
        <PostComment
            v-for="comment in comments"
            :key="comment.id"
            :ref="`comment-${comment.id}`"
            :post="post"
            :comment="comment"
            class="comment"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType, VNode } from 'vue';
import { mapGetters } from 'vuex';
import { smoothScroll } from '@/helpers/dom';
import type { PostResource } from '@/api/backend/resources/PostResource';
import type { PostCommentResource } from '@/api/backend/resources/PostCommentResource';
import PostComment from './PostComment.vue';

export default defineComponent({
    name: 'PostCommentList',
    components: { PostComment },
    props: {
        /**
         * Post object
         */
        post: {
            type: Object as PropType<PostResource>,
            required: true,
        },
        /**
         * Array of comments
         */
        comments: {
            type: Array as PropType<PostCommentResource[]>,
            required: true,
        },
    },
    computed: {
        ...mapGetters('ui', ['topBarHeight']),
        showList() {
            return this.comments.length > 0;
        },
    },
    methods: {
        async scrollToComment(commentId: number, tries = 1): Promise<void> {
            const postComment = (this.$refs[`comment-${commentId}`] as VNode[])?.[0];
            if (!postComment?.el) {
                await this.$nextTick();
                return tries ? this.scrollToComment(commentId, tries - 1) : undefined;
            }

            return smoothScroll(window, { top: postComment.el.offsetTop - this.topBarHeight });
        },
    },
});
</script>
<style lang="scss" scoped>
.comment:not(:first-child) {
    @apply mt-3 pt-3 border-t;
}
</style>
